import type React from 'react';
import type { ImageData } from '../../types/ChatWindow';

const ImageMessage: React.FC<{ data: ImageData }> = ({ data: { url } }) => {
  return <img className='image-message' alt='' src={url} />;
};

export default ImageMessage;
